L.DistortableImage = L.DistortableImage || {};

// this class holds the keybindings and toolbar API for an image collection instance
L.DistortableCollection.Edit = L.Handler.extend({
  options: {
    keymap: L.distortableImage.group_action_map,
  },

  initialize: function(group, options) {
    this._group = group;
    this._exportOpts = group.options.exportOpts;

    L.setOptions(this, options);

    L.distortableImage.group_action_map.Escape = '_decollectAll';
  },

  addHooks: function() {
    var group = this._group;
    var map = group._map;

    this.editActions = this.options.actions;
    this.runExporter =
        L.bind(L.Utils.getNestedVal(this, '_exportOpts', 'exporter') ||
        this.startExport, this);

    L.DomEvent.on(document, 'keydown', this._onKeyDown, this);

    if (!(map.doubleClickZoom.enabled() || map.doubleClickLabels.enabled())) {
      L.DomEvent.on(map, 'click', this._decollectAll, this);
    }

    L.DomEvent.on(map, {
      singleclickon: this._singleClickListeners,
      singleclickoff: this._resetClickListeners,
      singleclick: this._singleClick,
      boxcollectend: this._addCollections,
    }, this);

    this._group.editable = true;
    this._group.eachLayer(layer => layer.editing.enable());
  },

  removeHooks: function() {
    var group = this._group;
    var map = group._map;

    L.DomEvent.off(document, 'keydown', this._onKeyDown, this);

    if (!(map.doubleClickZoom.enabled() || map.doubleClickLabels.enabled())) {
      L.DomEvent.off(map, 'click', this._decollectAll, this);
    }

    L.DomEvent.off(map, {
      singleclickon: this._singleClickListeners,
      singleclickoff: this._resetClickListeners,
      singleclick: this._singleClick,
      boxcollectend: this._addCollections,
    }, this);

    this._decollectAll();
    this._group.editable = false;
    this._group.eachLayer(layer => layer.editing.disable());
  },

  enable: function() {
    this._enabled = true;
    this.addHooks();
    return this;
  },

  disable: function() {
    this._enabled = false;
    this.removeHooks();

    return this;
  },

  _onKeyDown: function(e) {
    var keymap = this.options.keymap;
    var handlerName = keymap[e.key];

    if (!this[handlerName]) { return; }

    if (this._group.anyCollected()) {
      this[handlerName].call(this);
    }
  },

  _singleClick: function(e) {
    if (e.type === 'singleclick') { this._decollectAll(e); }
    else { return; }
  },

  _singleClickListeners: function() {
    var map = this._group._map;
    L.DomEvent.off(map, 'click', this._decollectAll, this);
    L.DomEvent.on(map, 'singleclick', this._decollectAll, this);
  },

  _resetClickListeners: function() {
    var map = this._group._map;
    L.DomEvent.on(map, 'click', this._decollectAll, this);
    L.DomEvent.off(map, 'singleclick', this._decollectAll, this);
  },

  _decollectAll: function(e) {
    var oe;

    if (e) { oe = e.originalEvent; }
    /**
     * prevents image deselection following the 'boxcollectend' event - note 'shift' must not be released until dragging is complete
     * also prevents deselection following a click on a disabled img by differentiating it from the map
     */
    if (oe && (oe.shiftKey || oe.target instanceof HTMLImageElement)) {
      return;
    }

    this._group.eachLayer((layer) => {
      L.DomUtil.removeClass(layer.getElement(), 'collected');
      layer.deselect();
    });

    this._removeToolbar();

    if (e) { L.DomEvent.stopPropagation(e); }
  },

  _unlockGroup: function() {
    if (!this.hasTool(L.UnlockAction)) { return; }
    this._group.eachLayer((layer) => {
      if (this._group.isCollected(layer)) {
        var edit = layer.editing;
        edit._unlock();
        // unlock updates the layer's handles; deselect to ensure they're hidden
        layer.deselect();
      }
    });
  },

  _lockGroup: function() {
    if (!this.hasTool(L.LockAction)) { return; }
    this._group.eachLayer((layer) => {
      if (this._group.isCollected(layer) ) {
        var edit = layer.editing;
        edit._lock();
        // map.addLayer also deselects the image, so we reselect here
        L.DomUtil.addClass(layer.getElement(), 'collected');
      }
    });
  },

  _addCollections: function(e) {
    var box = e.boxCollectBounds;
    var map = this._group._map;

    this._group.eachLayer((layer) => {
      var edit = layer.editing;

      if (layer.isSelected()) { layer.deselect(); }

      var imgBounds = L.latLngBounds(layer.getCorner(2), layer.getCorner(1));
      var zoom = map.getZoom();
      var center = map.getCenter();
      imgBounds = map._latLngBoundsToNewLayerBounds(imgBounds, zoom, center);
      if (box.intersects(imgBounds) && edit.enabled()) {
        if (!this.toolbar) { this._addToolbar(); }
        L.DomUtil.addClass(layer.getElement(), 'collected');
      }
    });
  },

  _removeGroup: function(e) {
    if (!this.hasTool(L.DeleteAction)) { return; }
    var layersToRemove = this._group._toRemove();
    var n = layersToRemove.length;

    if (n === 0) { return; }

    var choice = L.DomUtil.confirmDeletes(n);

    if (choice) {
      layersToRemove.forEach((layer) => {
        this._group.removeLayer(layer);
      });
      if (!this._group.anyCollected()) {
        this._removeToolbar();
      }
    }

    if (e) { L.DomEvent.stopPropagation(e); }
  },

  cancelExport: function() {
    if (!this.customCollection) {
      this._exportOpts.collection = undefined;
    }

    clearInterval(this.updateInterval);
  },

  _addToolbar: function() {
    var group = this._group;
    var map = group._map;

    if (group.options.suppressToolbar || this.toolbar) { return; }

    this.toolbar = L.distortableImage.controlBar({
      actions: this.editActions,
      position: 'topleft',
    }).addTo(map, group);
  },

  _removeToolbar: function() {
    var map = this._group._map;
    if (this.toolbar) {
      map.removeLayer(this.toolbar);
      this.toolbar = false;
    } else {
      return false;
    }
  },

  hasTool: function(value) {
    return this.editActions.some(action => action === value);
  },

  addTool: function(value) {
    if (value.baseClass === 'leaflet-toolbar-icon' && !this.hasTool(value)) {
      this._removeToolbar();
      this.editActions.push(value);
      this._addToolbar();
    }
    return this;
  },

  removeTool: function(value) {
    this.editActions.some((item, idx) => {
      if (this.editActions[idx] === value) {
        this._removeToolbar();
        this.editActions.splice(idx, 1);
        this._addToolbar();
        return true;
      } else {
        return false;
      }
    });
    return this;
  },

  startExport: function() {
    if (!this.hasTool(L.ExportAction)) { return; }
    return new Promise(function(resolve) {
      var opts = this._exportOpts;
      opts.resolve = resolve; // allow resolving promise in user-defined functions, to stop spinner on completion
      var statusUrl;
      var self = this;
      this.updateInterval = null;

      // this may be overridden to update the UI to show export progress or completion
      function _defaultUpdater(data) {
        data = JSON.parse(data);
        // optimization: fetch status directly from google storage:
        if (data.status_url) {
          if (statusUrl !== data.status_url && data.status_url.match('.json')) {
            // if (data.status_url && data.status_url.substr(0,1) === "/") {
            //   opts.statusUrl = opts.statusUrl + data.status_url;
            // } else {
            statusUrl = data.status_url;
            // }
          }

          if (data.status === 'complete') {
            clearInterval(self.updateInterval);

            if (!self.customCollection) {
              self._exportOpts.collection = undefined;
            }

            resolve();
            if (data.jpg !== null) {
              alert('Export succeeded. ' + opts.exportUrl + data.jpg);
            }
          }

          // TODO: update to clearInterval when status == "failed" if we update that in this file:
          // https://github.com/publiclab/mapknitter-exporter/blob/main/lib/mapknitterExporter.rb
          console.log(data);
        }
      }

      // receives the URL of status.json, and starts running the updater to repeatedly fetch from status.json;
      // this may be overridden to integrate with any UI
      function _defaultHandleStatusRes(data) {
        statusUrl = opts.statusUrl + data;
        // repeatedly fetch the status.json
        self.updateInterval = setInterval(function intervalUpdater() {
          var request = new Request(statusUrl+'?'+Date.now(), {method: 'GET'});
          fetch(request).then(function(response) {
            if (response.ok) {
              return response.text();
            }
          }).then(opts.updater);
        }, opts.frequency);
      }

      // initiate the export
      function _defaultFetchStatusUrl(opts) {
        var form = new FormData();
        form.append('collection', JSON.stringify(opts.collection));
        form.append('scale', opts.scale);
        form.append('upload', true);
        var requestOptions = {method: 'POST', body: form};
        var request = new Request(opts.exportStartUrl, requestOptions);
        fetch(request).then(function(response) {
          if (response.ok) {
            return response.text();
          }
        }).then(opts.handleStatusRes);
      }

      // If the user has passed collection property
      if (opts.collection) {
        self.customCollection = true;
      } else {
        self.customCollection = false;
        opts.collection = this._group.generateExportJson().images;
      }

      opts.frequency = opts.frequency || 3000;
      opts.scale = opts.scale || 100; // switch it to _getAvgCmPerPixel !
      opts.updater = opts.updater || _defaultUpdater;
      opts.handleStatusRes = opts.handleStatusRes || _defaultHandleStatusRes;
      opts.fetchStatusUrl = opts.fetchStatusUrl || _defaultFetchStatusUrl;

      opts.fetchStatusUrl(opts);
    }.bind(this));
  },
});

L.distortableCollection.edit = function(group, options) {
  return new L.DistortableCollection.Edit(group, options);
};
